import { cn } from '@/lib/utils'
import * as React from 'react'

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, style, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('block text-sm font-medium text-[var(--text-primary)] mb-[var(--space-2)] peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
      style={style}
      {...props}
    />
  )
)
Label.displayName = 'Label'

export { Label }

